import { Typography } from "@mui/material";
import { jsx as _jsx } from "react/jsx-runtime";
export function SectionTitle(props) { return /*#__PURE__*/ _jsx(Typography, { variant: "h2", style: { fontSize: "1.2rem", fontWeight: 500 }, children: props.children }); }
